<template>
    <div class="admin-shell">
        <!-- 侧边栏 -->
        <aside class="admin-side">
            <div class="side-brand">
                <span class="brand-mark">信</span>
                <span class="brand-name">信 箱 后 台</span>
            </div>

            <nav class="side-nav">
                <a
                    class="nav-item"
                    :class="{ active: nav === 'pages' }"
                    @click="go('/admin/pages')"
                >
                    <span class="nav-ico">▤</span> 页面管理
                </a>
                <a
                    class="nav-item"
                    :class="{ active: nav === 'create' }"
                    @click="go('/admin/edit')"
                >
                    <span class="nav-ico">＋</span> 新建页面
                </a>
                <a
                    class="nav-item"
                    :class="{ active: nav === 'visits' }"
                    @click="go('/admin/visits')"
                >
                    <span class="nav-ico">◷</span> 访问记录
                </a>
                <a class="nav-item" @click="openSite">
                    <span class="nav-ico">↗</span> 打开前台
                </a>
            </nav>

            <div class="side-foot">
                <div class="api-line" :title="API_BASE">接口：{{ API_BASE }}</div>
                <button class="btn-ghost" @click="logout">退出登录</button>
            </div>
        </aside>

        <!-- 主区域 -->
        <main class="admin-main">
            <header class="admin-head">
                <h2 class="head-title">{{ title }}</h2>
                <div class="head-right">
                    <span class="head-sub" v-if="subtitle">{{ subtitle }}</span>
                </div>
            </header>

            <div class="admin-body">
                <router-view @changed="reloadKey++" :key="reloadKey" />
            </div>
        </main>
    </div>
</template>

<script>
import { API_BASE, clearToken, getToken } from './api';

export default {
    name: 'AdminLayout',
    data() {
        return {
            API_BASE,
            reloadKey: 0
        };
    },
    computed: {
        nav() {
            const p = this.$route.path;
            if (p.indexOf('/admin/pages') === 0) return 'pages';
            if (p.indexOf('/admin/edit') === 0) return 'create';
            if (p.indexOf('/admin/visits') === 0) return 'visits';
            return '';
        },
        title() {
            const p = this.$route.path;
            if (p.indexOf('/admin/edit') === 0) {
                return this.$route.query.id ? '编辑页面' : '新建页面';
            }
            if (p.indexOf('/admin/visits') === 0) return '访问记录';
            if (p.indexOf('/admin/preview') === 0) return '页面预览';
            return '页面管理';
        },
        subtitle() {
            const p = this.$route.path;
            if (p.indexOf('/admin/visits') === 0) return '用户访问明细：IP / 账号 / 时间 / 访问页面';
            return this.$route.query.id ? '' : '发布 / 编辑 / 维护「信箱」内容';
        }
    },
    created() {
        if (!getToken()) {
            this.$router.replace('/admin/login');
        }
    },
    methods: {
        go(path) {
            if (this.$route.path !== path) {
                this.$router.push(path);
            }
        },
        openSite() {
            window.open(window.location.origin + '/#/forzl', '_blank');
        },
        logout() {
            clearToken();
            this.$router.replace('/admin/login');
        }
    }
};
</script>

<style lang="less" scoped>
.admin-shell {
    display: flex;
    min-height: 100vh;
    background: #f6f2ec;
    color: #3f3126;
}

/* ---------------- 侧边栏 ---------------- */
.admin-side {
    width: 208px;
    flex: none;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    background: #2f2620;
    padding: 22px 14px 16px;
}

.side-brand {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 6px 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    .brand-mark {
        width: 30px;
        height: 30px;
        flex: none;
        border-radius: 8px;
        background: linear-gradient(140deg, #cf1f3d, #a3122e);
        color: #fff;
        font-size: 15px;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .brand-name {
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 2px;
        color: #f0e4d8;
    }
}

.side-nav {
    margin-top: 16px;
    flex: 1;
}
.nav-item {
    display: flex;
    align-items: center;
    gap: 9px;
    height: 40px;
    padding: 0 12px;
    margin-bottom: 4px;
    font-size: 13.5px;
    color: #c9b8a6;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.18s, color 0.18s;
    user-select: none;
    &:hover {
        background: rgba(255, 255, 255, 0.07);
        color: #f4e9dd;
    }
    &.active {
        background: linear-gradient(90deg, rgba(207, 31, 61, 0.9), rgba(163, 18, 46, 0.75));
        color: #fff;
        font-weight: 600;
    }
    .nav-ico {
        width: 16px;
        text-align: center;
        font-size: 13px;
        opacity: 0.9;
    }
}

.side-foot {
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    padding-top: 14px;
}
.api-line {
    font-size: 11px;
    color: #8d7a68;
    word-break: break-all;
    margin-bottom: 10px;
    line-height: 1.5;
}
.btn-ghost {
    width: 100%;
    height: 32px;
    font-size: 12.5px;
    color: #d8c8b8;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 7px;
    cursor: pointer;
    transition: background 0.18s;
    &:hover {
        background: rgba(255, 255, 255, 0.08);
    }
}

/* ---------------- 主区域 ---------------- */
.admin-main {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
}

.admin-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 62px;
    padding: 0 26px;
    background: #fff;
    border-bottom: 1px solid #ebdfd0;
    .head-title {
        margin: 0;
        font-size: 17px;
        font-weight: 600;
        color: #4a3629;
    }
    .head-sub {
        font-size: 12.5px;
        color: #a08a76;
    }
}

.admin-body {
    flex: 1;
    padding: 22px 26px 40px;
}
</style>

<!-- 后台通用控件样式（不加 scoped，供 pages/edit/preview 复用） -->
<style lang="less">
.admin-shell {
    /* ---- 按钮 ---- */
    .a-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
        height: 32px;
        padding: 0 14px;
        font-size: 12.5px;
        color: #5b4636;
        background: #fff;
        border: 1px solid #dfcdb8;
        border-radius: 7px;
        cursor: pointer;
        white-space: nowrap;
        transition: all 0.18s;
        &:hover {
            border-color: #c9ab8c;
            background: #fdf9f4;
        }
        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }
        &.primary {
            color: #fff;
            background: linear-gradient(140deg, #cf1f3d, #a3122e);
            border-color: transparent;
            &:hover {
                opacity: 0.92;
            }
        }
        &.danger {
            color: #a3122e;
            border-color: #f0c4cd;
            background: #fff6f8;
            &:hover {
                background: #fdeaee;
            }
        }
        &.mini {
            height: 26px;
            padding: 0 10px;
            font-size: 12px;
        }
    }

    /* ---- 状态徽标 ---- */
    .a-badge {
        display: inline-block;
        padding: 2px 9px;
        font-size: 11.5px;
        line-height: 18px;
        border-radius: 999px;
        &.pub {
            color: #1c7a4a;
            background: #e7f6ee;
            border: 1px solid #c4e8d5;
        }
        &.draft {
            color: #8a6a2a;
            background: #fdf4e2;
            border: 1px solid #f0e0bc;
        }
        &.off {
            color: #7a6553;
            background: #f1ece6;
            border: 1px solid #e2d8cd;
        }
    }

    /* ---- 卡片 / 表格 ---- */
    .a-card {
        background: #fff;
        border: 1px solid #ebdfd0;
        border-radius: 12px;
        box-shadow: 0 6px 20px rgba(120, 86, 44, 0.06);
    }

    .a-toolbar {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
        padding: 14px 18px;
        border-bottom: 1px solid #f0e6da;
    }

    .a-input,
    .a-select {
        height: 32px;
        box-sizing: border-box;
        padding: 0 10px;
        font-size: 12.5px;
        color: #3f3126;
        background: #fdfaf6;
        border: 1px solid #e0cdb6;
        border-radius: 7px;
        outline: none;
        &:focus {
            border-color: #cf1f3d;
            background: #fff;
            box-shadow: 0 0 0 3px rgba(207, 31, 61, 0.08);
        }
    }

    .a-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 13px;
        th {
            padding: 11px 12px;
            text-align: left;
            font-size: 12px;
            font-weight: 600;
            color: #8a7360;
            background: #fdfaf6;
            border-bottom: 1px solid #eee2d5;
            white-space: nowrap;
        }
        td {
            padding: 12px;
            border-bottom: 1px solid #f4ece2;
            color: #4a3f35;
            vertical-align: middle;
        }
        tbody tr:hover td {
            background: #fdfaf5;
        }
        .col-id {
            width: 52px;
            color: #a89383;
        }
        .col-ops {
            white-space: nowrap;
        }
    }

    .a-title-cell {
        .t-main {
            font-size: 13.5px;
            font-weight: 600;
            color: #3f3126;
            line-height: 1.5;
        }
        .t-code {
            margin-top: 3px;
            font-size: 11.5px;
            color: #a89383;
            code {
                padding: 1px 5px;
                color: #8a6a52;
                background: #f6efe6;
                border-radius: 4px;
            }
        }
    }

    .a-empty {
        padding: 60px 20px;
        text-align: center;
        color: #a89383;
        font-size: 13px;
    }

    .a-pager {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 10px;
        padding: 14px 18px;
        font-size: 12.5px;
        color: #8a7360;
    }

    /* ---- 轻提示 ---- */
    .a-toast {
        position: fixed;
        top: 22px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 9999;
        padding: 10px 20px;
        font-size: 13px;
        color: #fff;
        background: rgba(47, 38, 32, 0.92);
        border-radius: 8px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
        &.ok {
            background: rgba(28, 122, 74, 0.95);
        }
        &.err {
            background: rgba(163, 18, 46, 0.95);
        }
    }

    /* ---- 表单 ---- */
    .a-form-row {
        margin-bottom: 18px;
        label.f-label {
            display: block;
            margin-bottom: 7px;
            font-size: 12.5px;
            color: #7a6553;
            font-weight: 500;
            .req {
                color: #cf1f3d;
                margin-left: 3px;
            }
            .f-tip {
                margin-left: 8px;
                font-weight: 400;
                color: #b0a094;
            }
        }
        .a-input,
        .a-select,
        textarea.a-input {
            width: 100%;
        }
    }

    textarea.a-input {
        min-height: 74px;
        padding: 9px 10px;
        line-height: 1.7;
        resize: vertical;
        font-family: inherit;
    }
}
</style>
